import { render, staticRenderFns } from "./video_detail.vue?vue&type=template&id=0e3791ac&scoped=true&"
import script from "./video_detail.vue?vue&type=script&lang=js&"
export * from "./video_detail.vue?vue&type=script&lang=js&"
import style0 from "./video_detail.vue?vue&type=style&index=0&id=0e3791ac&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e3791ac",
  null
  
)

export default component.exports